import React, { useState } from "react";
import "./support.css";
import { Grid, TextField } from "@mui/material";
import Information from "../../assets/support/information.png";
import Demo from "../../assets/support/Demo.png";
import Buy from "../../assets/support/buy.png";
import Videocall from "../../assets/support/video_call.png";
import Timesheet from "../../assets/support/time_sheet.png";
import { TextareaAutosize, Button, Box } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import Pdf from "../../assets/keylong.pdf";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Keylongvideo from "../../assets/keylongdemo.mp4";

export default function Support() {
  const [open, openModal] = React.useState(false);

  const [error, setError] = React.useState("");

  const [Last_Name, setLast_Name] = useState("");
  const [First_Name, setFirst_Name] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [Account_Name, setAccount_Name] = useState("");
  const [Description, setDescription] = useState("");

  const submitTechnicalForm = (e) => {
    if (
      !Last_Name ||
      !First_Name ||
      !Email ||
      !Phone ||
      !Account_Name ||
      !Description
    ) {
      setError("Please fill all the required fields");
    } else {
      let Submitbtn = document.getElementById("formsubmit");
      Submitbtn.click();
    }
  };

  const handleClickOpen = () => {
    openModal(!open);
  };
  const handleClose = () => {
    // setOpen({ open: false });
    openModal(!open);
  };

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
  };

  const navigate = useNavigate();
  const onTimeSheet = () => {
    window.open(Pdf, "_blank");
  };

  const onBuy = () => {
    navigate("/pricing");
  };

  const onDemo = () => {
    navigate("/demo");
  };

  let arr = [
    {
      title: "Data Sheet",
      imgUrl: Timesheet,
      onClick: onTimeSheet,
    },
    {
      title: "Quick Start guid",
      imgUrl: Information,
    },

    {
      title: "Demo",
      imgUrl: Demo,
      onClick: onDemo,
    },
    {
      title: "Buy Now",
      imgUrl: Buy,
      onClick: onBuy,
    },

    {
      title: "How to video",
      imgUrl: Videocall,
      onClick: handleClickOpen,
    },
  ];

  return (
    <React.Fragment>
      <div className="support-background">
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            flexDirection: "column",
            padding: "174px 110px",
          }}
        >
          <h2
            style={{
              fontSize: "40px",
              color: "#fff",
              fontFamily: "pipins",
              fontWeight: 600,
            }}
          >
            We're here to help
          </h2>
          <h5
            style={{
              textDecoration: "none",
              color: "#fff",
              fontSize: "30px",
              fontFamily: "popins",
              fontWeight: 500,
              borderBottom: "3px solid",
              borderRadius: "2px",
            }}
          >
            Product Support &nbsp; &nbsp; &nbsp;{" "}
          </h5>

          <div className="section-support" style={{ padding: "40px 0px" }}>
            {arr.map((entity, i) => {
              return (
                <div
                  className="support"
                  key={i}
                  onClick={() => entity.onClick()}
                >
                  <div className="support-outer-boxs">
                    <img
                      alt="Product"
                      src={entity.imgUrl}
                      height="60px"
                      width="60px"
                    />
                    <BootstrapDialog
                      style={{ alignItems: "center", alignContent: "center" }}
                      onClose={() => {
                        this.handleModal();
                      }}
                      aria-labelledby="customized-dialog-title"
                      open={open}
                    >
                      <DialogContent dividers>
                        <BootstrapDialogTitle>
                          How to Video
                          <p
                            style={{ fontSize: "12px", fontFamily: "Poppins" }}
                          >
                            Here are some of the videos help to understand
                            products
                          </p>
                        </BootstrapDialogTitle>
                        <Typography gutterBottom>
                          <div className="modal__video-style">
                            <iframe
                              loading="lazy"
                              width="560"
                              height="315"
                              scrolling="no"
                              src={Keylongvideo}
                              title="YouTube video player"
                              frameBorder="0"
                              allowFullScreen
                              onPause={false}
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            ></iframe>
                          </div>
                        </Typography>
                      </DialogContent>
                    </BootstrapDialog>
                  </div>

                  <p
                    style={{
                      fontWeight: "500",
                      color: "#00327E",
                      fontSize: "15px",
                    }}
                  >
                    {entity.title}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="support-card-container">
        <div style={{ margin: "40px" }}>
          <h2
            style={{
              color: "#263238",
              fontSize: "30px",
              fontFamily: "popins",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            Technical Support
          </h2>
          <p
            style={{
              color: "#263238",
              fontSize: "20px",
              fontFamily: "popins",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            {" "}
            Please Fill Information
          </p>
          <div
            id="crmWebToEntityForm"
            className="zcwf_lblLeft crmWebToEntityForm"
            style={{ backgroundColor: "white", color: "black", maxWidth: 800 }}
          >
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0"
            />
            <meta httpEquiv="content-type" content="text/html;charset=UTF-8" />
            <form
              action="https://crm.zoho.com/crm/WebToContactForm"
              name="WebToContacts129652000050059007"
              method="POST"
              encType="multipart/form-data"
              onsubmit='javascript:document.charset="UTF-8"; return checkMandatory129652000050059007()'
              acceptCharset="UTF-8"
            >
              <input
                type="text"
                style={{ display: "none" }}
                name="xnQsjsdp"
                defaultValue="485a6233e33ff9469c544f480893639484d1a7e2a844f16c4c645f791586cb5c"
              />
              <input type="hidden" name="zc_gad" id="zc_gad" defaultValue="" />
              <input
                type="text"
                style={{ display: "none" }}
                name="xmIwtLD"
                defaultValue="832a349b02accc5cfad05c9d613653f4dfedfb17faa641cd9755730f1199128e"
              />
              <input
                type="text"
                style={{ display: "none" }}
                name="actionType"
                defaultValue="Q29udGFjdHM="
              />
              <input
                type="text"
                style={{ display: "none" }}
                name="returnURL"
                defaultValue="https://www.keylong.io/"
              />
              {/* Do not remove this code. */}
              <style
                dangerouslySetInnerHTML={{
                  __html:
                    "\nhtml,body{\n      margin: 0px;\n}\n#crmWebToEntityForm.zcwf_lblLeft {\n      width:100%;\n      padding: 25px;\n      margin: 0 auto;\n      box-sizing: border-box;\n}\n#crmWebToEntityForm.zcwf_lblLeft * {\n      box-sizing: border-box;\n}\n#crmWebToEntityForm{text-align: left;}\n#crmWebToEntityForm * {\n      direction: ltr;\n}\n.zcwf_lblLeft .zcwf_title {\n      word-wrap: break-word;\n      padding: 0px 6px 10px;\n      font-weight: bold;\n}\n.zcwf_lblLeft .zcwf_col_fld input[type=text], .zcwf_lblLeft .zcwf_col_fld textarea {\n      width: 60%;\n      border: 1px solid #c0c6cc !important;\n      resize: vertical;\n      border-radius: 2px;\n      float: left;\n}\n.zcwf_lblLeft .zcwf_col_lab {\n      width: 30%;\n      word-break: break-word;\n      padding: 0px 6px 0px;\n      margin-right: 10px;\n      margin-top: 5px;\n      float: left;\n      min-height: 1px;\n}\n.zcwf_lblLeft .zcwf_col_fld {\n      float: left;\n      width: 68%;\n      padding: 0px 6px 0px;\n      position: relative;\n      margin-top: 5px;\n}\n.zcwf_lblLeft .zcwf_privacy{padding: 6px;}\n.zcwf_lblLeft .wfrm_fld_dpNn{display: none;}\n.dIB{display: inline-block;}\n.zcwf_lblLeft .zcwf_col_fld_slt {\n      width: 60%;\n      border: 1px solid #ccc;\n      background: #fff;\n      border-radius: 4px;\n      font-size: 14px;\n      float: left;\n      resize: vertical;\n      padding: 2px 5px;\n}\n.zcwf_lblLeft .zcwf_row:after, .zcwf_lblLeft .zcwf_col_fld:after {\n      content: '';\n      display: table;\n      clear: both;\n}\n.zcwf_lblLeft .zcwf_col_help {\n      float: left;\n      margin-left: 7px;\n      font-size: 14px;\n      max-width: 35%;\n      word-break: break-word;\n}\n.zcwf_lblLeft .zcwf_help_icon {\n      cursor: pointer;\n      width: 16px;\n      height: 16px;\n      display: inline-block;\n      background: #fff;\n      border: 1px solid #c0c6cc;\n      color: #c1c1c1;\n      text-align: center;\n      font-size: 11px;\n      line-height: 16px;\n      font-weight: bold;\n      border-radius: 50%;\n}\n.zcwf_lblLeft .zcwf_row {margin: 15px 0px;}\n.zcwf_lblLeft .formsubmit {\n      margin-right: 5px;\n      cursor: pointer;\n      color: var(--baseColor);\n      font-size: 14px;\n}\n.zcwf_lblLeft .zcwf_privacy_txt {\n      width: 90%;\n      color: rgb(0, 0, 0);\n      font-size: 14px;\n      font-family: Arial;\n      display: inline-block;\n      vertical-align: top;\n      color: var(--baseColor);\n      padding-top: 2px;\n      margin-left: 6px;\n}\n.zcwf_lblLeft .zcwf_button {\n      font-size: 14px;\n      color: var(--baseColor);\n      border: 1px solid #c0c6cc;\n      padding: 3px 9px;\n      border-radius: 4px;\n      cursor: pointer;\n      max-width: 120px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.zcwf_lblLeft .zcwf_tooltip_over{\n      position: relative;\n}\n.zcwf_lblLeft .zcwf_tooltip_ctn{\n      position: absolute;\n      background: #dedede;\n      padding: 3px 6px;\n      top: 3px;\n      border-radius: 4px;word-break: break-word;\n      min-width: 100px;\n      max-width: 150px;\n      color: var(--baseColor);\n      z-index: 100;\n}\n.zcwf_lblLeft .zcwf_ckbox{\n      float: left;\n}\n.zcwf_lblLeft .zcwf_file{\n      width: 55%;\n      box-sizing: border-box;\n      float: left;\n}\n.clearB:after{\n      content:'';\n      display: block;\n      clear: both;\n}\n@media all and (max-width: 800px) {\n      .zcwf_lblLeft .zcwf_col_lab, .zcwf_lblLeft .zcwf_col_fld {\n            width: auto;\n            float: none !important;\n      }\n      .zcwf_lblLeft .zcwf_col_help {width: 40%;}\n}\n",
                }}
              />
              {/* <div
                className="zcwf_title"
                style={{ maxWidth: 800, color: "black" }}
              >
                Keylong Technical Support
              </div> */}
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Last_Name">
                    Last Name<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="Last_Name"
                    name="Last Name"
                    maxLength={30}
                    onClick={setLast_Name}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="First_Name">
                    First Name<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="First_Name"
                    name="First Name"
                    maxLength={30}
                    onClick={setFirst_Name}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Email">
                    Email<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    ftype="email"
                    id="Email"
                    name="Email"
                    maxLength={30}
                    onClick={setEmail}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Phone">
                    Phone<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="Phone"
                    name="Phone"
                    maxLength={15}
                    onClick={setPhone}
                  />

                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Account_Name">
                    Company<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="Account_Name"
                    name="Account Name"
                    maxLength={30}
                    onClick={setAccount_Name}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Description">
                    Please explain problem you face
                    <span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <textarea
                    id="Description"
                    name="Description"
                    defaultValue={""}
                    onClick={setDescription}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  Upload a File
                </div>
                <div className="zcwf_col_fld">
                  <div className="clearB">
                    <input
                      type="file"
                      className="zcwf_file"
                      name="theFile"
                      id="theFile129652000050059007"
                      multiple=""
                    />
                    <div className="zcwf_col_help" />
                  </div>
                  <p style={{ color: "black", fontSize: 11, paddingLeft: 3 }}>
                    File(s) size limit is 20MB.
                  </p>
                </div>
              </div>
              <div className="zcwf_row wfrm_fld_dpNn">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Lead_Source">Lead Source</label>
                </div>
                <div className="zcwf_col_fld">
                  <select
                    className="zcwf_col_fld_slt"
                    id="Lead_Source"
                    name="Lead Source"
                  >
                    <option value="-None-">-None-</option>
                    <option selected="" value="Website">
                      Website
                    </option>
                    <option value="Referral">Referral</option>
                    <option value="Email Campaign">Email Campaign</option>
                    <option value="Telemarketing">Telemarketing</option>
                    <option value="Advert / PR">Advert / PR</option>
                    <option value="Show / Seminar">Show / Seminar</option>
                    <option value="Facebook">Facebook</option>
                    <option value="Twitter">Twitter</option>
                    <option value="Google+">Google+</option>
                  </select>
                  <div className="zcwf_col_help" />
                </div>
              </div>
              {error && (
                <div style={{ color: "red", textAlign: "center" }}>
                  {`*` + error}
                </div>
              )}
              <div className="zcwf_row">
                <div className="zcwf_col_lab" />
                <div className="zcwf_col_fld">
                  <Button
                    style={{
                      backgroundColor: "#0047B3",
                      color: "#fff",
                    }}
                    onClick={(e) => submitTechnicalForm(e)}
                  >
                    Submit
                  </Button>
                  <input
                    style={{ display: "none" }}
                    type="submit"
                    id="formsubmit"
                    className="formsubmit zcwf_button"
                    defaultValue="Submit"
                    title="Submit"
                  />
                  <input
                    type="reset"
                    className="zcwf_button"
                    name="reset"
                    defaultValue="Reset"
                    title="Reset"
                  />
                </div>
              </div>
              {/* Do not remove this --- Analytics Tracking code starts */}
              {/* Do not remove this --- Analytics Tracking code ends. */}
            </form>
          </div>
        </div>
      </div>
      <div style={{ height: "100vh " }}></div>;
    </React.Fragment>
  );
}
